import React from "react";
import { skills } from "data/skills.js";
import SkillSection from "./SkillSection";

const Skill = () => {
  return (
    <div className="new-tab-content-container">
      <SkillSection title="Language" data={skills.languages} />
      <SkillSection title="Frontend" data={skills.frontend} />
      <SkillSection title="Backend" data={skills.backend} />
      <SkillSection title="Databases" data={skills.databases} />
      <SkillSection title="Others" data={skills.others} />
    </div>
  );
};

export default Skill;
